import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, Stack, Button, Box, CircularProgress } from '@mui/material';
import { DialogProps } from '@toolpad/core/useDialogs';
import { useTranslation } from 'react-i18next';
import PasswordField from '@/components/inputs/PasswordField/PasswordField';

export function StudentResetPasswordDialog({ open, onClose }: DialogProps<undefined, string | null>) {
    const { t } = useTranslation();

    // ui
    const [saving, setSaving] = React.useState(false);
    const [passwordError, setPasswordError] = React.useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');

    const validateInputs = () => {
        const password = document.getElementById('password') as HTMLInputElement;

        let isValid = true;

        if (!password.value || password.value.length < 8) {
            setPasswordError(true);
            setPasswordErrorMessage(t('common.form.invalidPassword'));
            isValid = false;
        } else {
            setPasswordError(false);
            setPasswordErrorMessage('');
        }

        return isValid;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();

        if (passwordError) {
            return;
        }

        const data = new FormData(event.currentTarget);
        const password = data.get('password') as string;

        setSaving(true);
        await onClose(password);
        setSaving(false);
    };

    return (
        <Dialog fullWidth open={open} onClose={() => onClose(null)}>
            <Box component='form' onSubmit={handleSubmit} noValidate>
                <DialogTitle>{t('student.actions.resetPassword')}</DialogTitle>
                <DialogContent>
                    <Stack sx={{ pt: 1 }} gap={2}>
                        <PasswordField required fullWidth error={passwordError} helperText={passwordErrorMessage} color={passwordError ? 'error' : 'primary'} />
                    </Stack>
                </DialogContent>
                <Stack direction='row' sx={{ justifyContent: 'flex-end', gap: 1, p: 1 }}>
                    <Button
                        onClick={async () => {
                            onClose(null);
                        }}
                    >
                        {t('common.cancel')}
                    </Button>
                    <Button loading={saving} variant='contained' type='submit' onClick={validateInputs} loadingIndicator={<CircularProgress size={16} />}>
                        {t('common.save')}
                    </Button>
                </Stack>
            </Box>
        </Dialog>
    );
}
